// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xg_a bhb_a bhb_x","StrollerDetailRating__muted":"xg_b bhb_fi"};